import { ComponentProps, ReactElement } from 'react';

import { getClasses } from '@/utils';

export type SkyhopPdfFooterSectionItemProps = ComponentProps<'li'>;

const SkyhopPdfFooterSectionItem = ({ ...props }: SkyhopPdfFooterSectionItemProps): ReactElement => (
  <li {...props} className={getClasses('SkyhopPdfFooter-Item', props.className)} />
);

export default SkyhopPdfFooterSectionItem;
